/**
 * What `getResolvedTestType` actually reads. Load a test with one of these
 * wherever you resolve its type — most often to build an admin link. Without
 * the `questions` probe every test resolves as "standard", so Q&A, glossary and
 * capability-map tests silently link to the wrong admin route.
 *
 * Use TEST_TYPE_INCLUDE with `include:` (scalars, and so the flags, come free)
 * and TEST_TYPE_SELECT_FIELDS with `select:` (the flags must be named).
 */
export const TEST_TYPE_INCLUDE = {
  questions: {
    select: {
      options: { take: 1, select: { id: true } },
    },
  },
};

export const TEST_TYPE_SELECT_FIELDS = {
  isFaqTest: true,
  isGlossaryTest: true,
  isFbivTest: true,
  ...TEST_TYPE_INCLUDE,
};

export function hasOptionBasedQuestions(test = {}) {
  const questions = Array.isArray(test?.questions) ? test.questions : [];

  return questions.some(
    (question) =>
      Array.isArray(question?.options) && question.options.length > 0
  );
}

export function getResolvedTestType(test = {}) {
  if (hasOptionBasedQuestions(test)) {
    return "standard";
  }

  if (test?.isFaqTest) {
    return "faq";
  }

  if (test?.isGlossaryTest) {
    return "glossary";
  }

  if (test?.isFbivTest) {
    return "fbiv";
  }

  return "standard";
}
